import React, { useEffect, useState } from 'react';
import {
  Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, Button, Box
} from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import SiteService from '../SiteService';
import DataThresholdingOutlinedIcon from '@mui/icons-material/DataThresholdingOutlined';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import PercentIcon from '@mui/icons-material/Percent';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const getChargeLabel = (chargeCode) => {
  if (chargeCode === 'ACTUAL_INVOICE_AMOUNT_DIFF') {
    return 'Fatura Tutar Farkı';
  }
  return chargeCode || 'Diğer Ücret';
};

const SubMeterDetailsModal = ({ open, onClose, subMeter }) => {
  const groupedByBucket = subMeter.details.reduce((acc, detail) => {
    if (!acc[detail.bucketName]) acc[detail.bucketName] = [];
    acc[detail.bucketName].push(detail);
    return acc;
  }, {});

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{subMeter.subMeterName} - Detaylar</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" gutterBottom>
          <ElectricalServicesIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
          Tüketim Detayları
        </Typography>
        {Object.entries(groupedByBucket).map(([bucketName, details], i) => (
          <Box key={i} mb={2}>
            <Typography fontWeight="bold">• {bucketName} Ücreti</Typography>
            {details.map((d, j) => (
              <Box key={j} pl={2}>
                <Typography>
                  <DataThresholdingOutlinedIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                  {d.thresholdName}
                </Typography>
                <Typography pl={2}>
                  {d.consumption} kWh * {d.unitPrice} TL → {d.amount.toFixed(2)} TL
                </Typography>
              </Box>
            ))}
          </Box>
        ))}

        <Typography variant="h6" gutterBottom mt={4}>
          <PercentIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
          Vergiler
        </Typography>
        {subMeter.taxes.length === 0 ? (
          <Typography>Vergi bulunamadı.</Typography>
        ) : (
          subMeter.taxes.map((tax, i) => (
            <Typography key={i}>
              • {tax.taxType} ({tax.taxRate.toFixed(2)}%): {tax.taxAmount.toFixed(2)} TL
              {tax.bucketName && ` (${tax.bucketName})`}
            </Typography>
          ))
        )}

        {/* Diğer Ücretler */}
        {subMeter.others && subMeter.others.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom mt={4}>
              <AttachMoneyIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
              Diğer Ücretler
            </Typography>
            {subMeter.others.map((other, i) => (
              <Typography key={i}>
                • {getChargeLabel(other.chargeCode)}: {other.amount.toFixed(2)} TL
              </Typography>
            ))}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

const RatingSummaryPage = () => {
  const { invoiceId, mainMeterId } = useParams();

  const [ratingResponse, setRatingResponse] = useState(null);
  const [selectedSubMeter, setSelectedSubMeter] = useState(null);

  useEffect(() => {
    console.log('geldi', mainMeterId, invoiceId);
    SiteService.getSubMeterCharges(mainMeterId, invoiceId).then((res) => {
      setRatingResponse(res.data);
    });
  }, [invoiceId]);

  if (!ratingResponse || !Array.isArray(ratingResponse.subMeterCharges)) return <Typography>Yükleniyor...</Typography>;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Fatura Özeti</Typography>
      <Typography variant="subtitle1" gutterBottom>
        Toplam Fatura Tutarı: {ratingResponse.totalAmount} TL
      </Typography>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sayaç Adı</TableCell>
              <TableCell>Tüketim Ücreti</TableCell>
              <TableCell>Vergiler</TableCell>
              <TableCell>Diğer Ücretler</TableCell>
              <TableCell>Toplam Ücret</TableCell>
              <TableCell>Detay</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ratingResponse.subMeterCharges.map((subMeter, i) => {
              const consumptionTotal = subMeter.details.reduce((sum, d) => sum + d.amount, 0);
              const taxTotal = subMeter.taxes.reduce((sum, t) => sum + t.taxAmount, 0);
              const othersTotal = subMeter.others 
                ? subMeter.others.reduce((sum, o) => sum + o.amount, 0) 
                : 0;
              
              return (
                <TableRow key={i}>
                  <TableCell>{subMeter.subMeterName}</TableCell>
                  <TableCell>{consumptionTotal.toFixed(2)} TL</TableCell>
                  <TableCell>{taxTotal.toFixed(2)} TL</TableCell>
                  <TableCell>{othersTotal.toFixed(2)} TL</TableCell>
                  <TableCell>{subMeter.amount.toFixed(2)} TL</TableCell>
                  <TableCell>
                    <Button variant="outlined" size="small" onClick={() => setSelectedSubMeter(subMeter)}>
                      Detayları Göster
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedSubMeter && (
        <SubMeterDetailsModal
          open={Boolean(selectedSubMeter)}
          onClose={() => setSelectedSubMeter(null)}
          subMeter={selectedSubMeter}
        />
      )}
    </Box>
  );
};

export default RatingSummaryPage;